<template>
  <div>
    <header>Это твой план. В некоторых модулях можно выбирать.</header>
    <v-list
            :shaped="true"
            :dense="true"
            :nav="true"
    >
        <v-list-item
                v-for="(step, i) in steps"
                :ripple="true"
                :key="i"
        >
          <v-list-item-content>
            <v-subheader>Модуль {{i+1}}</v-subheader>
            <ul>
              <div v-for="(section, j) in step" :key="j">
                <div :class="isAllowForChoice(section.options) ? '' : 'text--disabled'">
                  <ul>
                    <div class="my-3" v-for="(ref, k) in section.refs" :key="k">
                      <div v-show="!isAllowForChoice(section.options)">
                        {{'Доступно если выбрать: ' +
                        section.options.required_concepts.map(c => $store.getters.conceptInTitle(c)).join(', ')}}
                      </div>
                      <div

                              v-if="section.refs.length > 1">
                        <span class="font-weight-light">{{ref.options.note}}</span>
                        <div>
                          <label>
                            <input
                                    v-if="section.options.allow_multiple_choice"
                                    @change="updateSelected"
                                    class="mr-3"
                                    :value="ref.concept"
                                    :disabled="!isAllowForChoice(section.options)"
                                    type="checkbox"
                                    v-model="selected[i]"
                            >
                            <input
                                    v-else
                                    @change="updateSelected"
                                    class="mr-3"
                                    :value="ref.concept"
                                    :disabled="!isAllowForChoice(section.options)"
                                    type="radio"
                                    v-model="selected[i][0]"
                            >
                            {{$store.getters.conceptInTitle(ref.concept)}}
                          </label>
                        </div>
                      </div>
                      <div v-else>
                        {{$store.getters.conceptInTitle(ref.concept)}}
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </ul>
          </v-list-item-content>
        </v-list-item>
    </v-list>
    <div class="d-flex justify-center ma-3">
      <v-btn
              v-if="onNextStep"
              :class="isConceptsSelected ? '': 'v-btn--disabled'"
              @click="() => onNextStep(convertSelected())"
              text
      >
        {{isConceptsSelected ? 'К кастомизации' : 'Выбери доступные варианты'}}
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PlanSettings",
    props: {
      roadmap: Object,
      selected: Array,
      onNextStep: Function,
      onPrevStep: Function,
    },
    data() {
      return {
        steps: this.roadmap.steps
      }
    },
    computed: {
      isConceptsSelected() {
        return this.selected.every(s => s !== null && s.length > 0);
      }
    },
    methods: {
      isAllowForChoice: function (options) {
        return options.required_concepts.every(c => this.selected.flat().includes(c))
      },
      convertSelected() {
        return this.selected.flat();
      },
      updateSelected() {
        this.steps.forEach((step, idx) => {
          for (let section of step) {
            const isAllow = this.isAllowForChoice(section.options);
            if (section.refs.length === 1 && isAllow) {
              this.selected[idx] = [section.refs[0].concept];
              return;
            }
          }
        });
      }
    },
    created() {
      this.updateSelected();
    }
  }
</script>

<style scoped>

</style>
